export { default } from './MobileAppLanding';
